import { BaseModel } from "sjs-base-model";

export default class TanBaseFormModel extends BaseModel {
    public readonly tanBase: string = "";
    public readonly idMotivCambioTan: number = 0;

    constructor(data: Partial<TanBaseFormModel>) {
        super();

        this.update(data);
    }
}
